import React, { Component } from 'react'
import Slider from 'react-slick'
import GalleryItem from './gallery-item'

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slideToShow: 1,
  slideToScroll: 1,
  arrows: false,
  customPaging: (i) => {
    return <a><span className='dot' /></a>
  }
}

export default class Gallery extends Component {
  render () {
    const itemsData = this.props.items || []
    const items = itemsData.map((content, i) => {
      if (content) {
        return <GalleryItem
          key={`ss-gi-${i}`}
          content={content}
        />
      }
      return null
    })

    return (
      <div className='gallery mt5 mb3 mb0-ns nl4 nr4 nl0-ns nr0-ns'>
        <Slider {...settings}>
          {items}
        </Slider>
      </div>
    )
  }
}
